<template>
  <div class="ts-dropdown-container" :class="{ opened }">
    <div class="tt-dropdown" :style="{background: colour}" @click="opened = !opened">
      <span>{{ labelText }}</span>
      <div class="chev"><div class="chev-down"></div></div>
    </div>

    <div class="tt-dropdown-content" v-if="opened">
      <ul>
        <li
          v-for="option in options"
          :key="option.key"
          @click="onSelected(option.key)"
          :class="{ toggled: toggled.includes(option.key) }"
        >
          {{ option.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',

  props: {
    label: {
      type: String,
      default: 'Select option',
    },
    colour: {
      type: String, 
      default: 'White'
    },
    options: {
      type: Array,
      required: true,
    },
    single: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      opened: false,
      toggled: [],
    };
  },

  computed: {
    labelText() {
      if (this.toggled.length < 1) {
        return this.label;
      } else if (this.toggled.length === 1) {
        return this.options.find(o => o.key === this.toggled[0]).label;
      }

      return 'Multiple selected';
    },
  },

  methods: {
    onSelected(k) {
      if (this.single) {
        // If it is a single select then close the dropdown immediately and only add one item to the array.
        this.toggled = [k];
        this.opened = false;
        this.$emit('input', k);
      } else {
        // If it is a multiple select then toggle it on the list if there is a change.
        const index = this.toggled.findIndex(i => i === k);

        if (index >= 0) {
          // Remove this item from the list.
          this.toggled.splice(index, 1);
        } else {
          this.toggled.push(k);
        }

        this.$emit('input', this.toggled);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ts-dropdown-container {
  position: relative;
  max-width: 300px;
  z-index: 1;

  &.opened {
    .tt-dropdown .chev .chev-down {
      transform: translate(-50%, -50%) rotateZ(180deg);
    }
  }
}

.tt-dropdown {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background-color: white;
  border-radius: 1000px 1000px 1000px 0;
  cursor: pointer;
  z-index: 0;

  > span {
    color: #3f4041;
    font-size: 13px;
    margin: 10px 15px;
  }

  .chev {
    position: relative;
    background-color: #1381a2;
    border-radius: 1000px 1000px 1000px 0;
    width: 35px;
    height: 35px;
  }
}

.tt-dropdown-content {
  position: absolute;
  top: 17px;
  padding: 26px 0 15px 0;
  z-index: -1;
  background: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 0 0 16px 16px;
  width: 100%;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      padding: 5px 15px;
      font-size: 15px;
      cursor: pointer;

      &.toggled {
        background-color: #ececec;
      }
    }
  }
}
</style>
